// src/components/PageLoading.js
// Drop-in replacement for the bare "Loading…" paragraphs on page-level loads.
// If loading hasn't settled after STALL_MS the Firestore connection has usually
// gone stale (laptop sleep, network switch, proxy killing the stream) — the SDK
// hangs silently while it backs off. A full reload opens a fresh connection,
// so offer that instead of a spinner that never ends.
import { useEffect, useState } from 'react';

const STALL_MS = 12000;

export default function PageLoading({ text = 'Loading…' }) {
  const [stalled, setStalled] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setStalled(true), STALL_MS);
    return () => clearTimeout(id);
  }, []);

  if (!stalled) {
    return <p style={{ color: 'var(--ink-muted)', padding: 32 }}>{text}</p>;
  }

  return (
    <div className="fade-up" style={{ padding: 32 }}>
      <div className="card" style={{ maxWidth: 460 }}>
        <div className="card-title">Still loading…</div>
        <p style={{ fontSize: '0.875rem', color: 'var(--ink-muted)', lineHeight: 1.7, marginBottom: 16 }}>
          This is taking longer than it should. That usually means the connection
          went stale — reloading the page fixes it.
        </p>
        <button className="btn btn-primary" onClick={() => window.location.reload()}>
          ↻ Reload page
        </button>
      </div>
    </div>
  );
}
